import { bindTypesToActions } from '@src/utils/redux_utils';

import analytics from '@src/firebase/analytics';
const types = {
  AddCourses: 'COURSE_ADD_COURSES',
  ClearCourses: 'COURSE_CLEAR_COURSES',
  SetIdentifier: 'COURSE_SET_IDENTIFIER',
  SetDisabledCourses: 'COURSE_UPDATE_DISABLED_COURSES',
  UpdateCourses: 'COURSE_UPDATE_COURSES',
  //saga actions:
  GetCourses: 'COURSE_GET_COURSES'
};

const CourseActions = bindTypesToActions( types );

const initialState = {
  uniqueId: null, /** profileid/level/language */
  courseList: [],
  page:1
};

const CourseReducer = (state = initialState, { type, payload }) => {
  
  switch (type) {
  
    case types.AddCourses:
      const { courses: newCourses } = payload ;
      if( !Array.isArray( newCourses ) || !newCourses.length ) return  state;
      return {
        ...state,
        page: state.page + 1,
        courseList: state.courseList.concat( newCourses )
      }

    case types.SetIdentifier:
      const { uniqueId } = payload ; 
        //if course changed:
      if( state.uniqueId !== uniqueId ) return {
              uniqueId ,
              courseList: [],
              page:1 
          } 
      else return state ;

    case types.SetDisabledCourses: 
      const { disabledCourses } = payload ;
      // analytics.logEvent( 'PARENTCONTROL', { CategoryNames: disabledCourses} )
      return {
        ...state,
        courseList: state.courseList.map( course =>{
          course.disabled = disabledCourses.includes( course.contentid );  
          return course ;
        })
      } ;
    case types.UpdateCourses:
      const { contents } = payload ;

      return {
        ...state,
        courseList: state.courseList.map( course =>{
          const matchContent = contents.find( content => content.contentid === course.contentid );
          
          const progress = matchContent?.progress ;
          if( progress ) course.progress = progress ;

          course.status = matchContent?.status ?? '' ;
          course.iscompletedonce = matchContent?.iscompletedonce ?? false ;

          return course ;
        })
      }      


    case types.ClearCourses:
      return initialState ;

    default:
      return state;
  }
};

export { types as CourseTypes, CourseReducer, CourseActions };
